module.exports = __webpack_public_path__ + "img/8@2x.b698383e.png";